"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const appStateSelectAppId_1 = __importDefault(require("../../shared/appStateSelectAppId"));
const appStateSelectProjectId_1 = __importDefault(require("../../shared/appStateSelectProjectId"));
const clientAppOnAuthenticated_1 = __importDefault(require("../clientAppOnAuthenticated"));
const buildAppLogin = (args) => async ({ functionId, entryVars: { email, password }, callbacks, executeProcesses, processor, store, }) => {
    if (typeof email !== 'string' || typeof password !== 'string' || !email || !password) {
        executeProcesses(functionId, callbacks.errorProcess, 'Email and password are required.');
        return;
    }
    const state = store.getState();
    const projectId = (0, appStateSelectProjectId_1.default)(state);
    const appId = (0, appStateSelectAppId_1.default)(state);
    if (!processor.root.isInDevelopment) {
        try {
            await processor.root.firebase.auth().signInWithEmailAndPassword(email, password);
            await (0, clientAppOnAuthenticated_1.default)({
                appId,
                processor,
                projectId,
            });
            executeProcesses(undefined, callbacks.successProcess);
        }
        catch (error) {
            executeProcesses(functionId, callbacks.errorProcess, `${error}`);
        }
        return;
    }
    try {
        const data = await processor.root.cloud.rendererLogIn({
            projectId,
            appId,
            email,
            password,
        });
        if (data.success && data.customToken) {
            await processor.root.firebase.auth().signInWithCustomToken(data.customToken);
            await (0, clientAppOnAuthenticated_1.default)({
                appId,
                processor,
                projectId,
            });
            if (args === null || args === void 0 ? void 0 : args.onUserLoggedInDevelopment) {
                await args.onUserLoggedInDevelopment({ appId });
            }
            executeProcesses(undefined, callbacks.successProcess);
        }
        else if (data.invalidCredentials) {
            executeProcesses(functionId, callbacks.invalidCredentials, data.error);
        }
        else {
            executeProcesses(functionId, callbacks.errorProcess, data.error);
        }
    }
    catch (error) {
        executeProcesses(functionId, callbacks.errorProcess, `${error}`);
    }
};
exports.default = buildAppLogin;
